export default function PhilosophySection() {
  return (
    <section className="w-full flex flex-col lg:flex-row min-h-[640px]">
      <div className="w-full lg:w-1/2 bg-background-100 relative overflow-hidden flex items-end p-10 md:p-16">
        <p className="absolute top-8 left-8 text-xs font-medium uppercase tracking-wider text-foreground-500 font-label">
          PHILOSOPHY
        </p>
        <div className="mb-8 md:mb-12">
          <p className="text-[clamp(48px,7vw,96px)] font-bold font-heading text-foreground-950 leading-[0.92]">
            CLEAN.
          </p>
          <p className="text-[clamp(56px,8vw,80px)] font-bold font-heading text-foreground-950 leading-[0.92] mt-1">
            SCALABLE.
          </p>
          <p className="text-[clamp(40px,6vw,64px)] font-bold font-heading text-foreground-950 leading-[0.92] mt-1">
            RELIABLE.
          </p>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-8 md:px-16 py-16 md:py-0">
        <h2 className="text-4xl md:text-5xl font-bold font-heading text-foreground-950 text-center leading-[1.15]">
          Engineering
          <br />
          with purpose
        </h2>

        <p className="text-base md:text-lg leading-relaxed text-foreground-600 font-body text-center max-w-[480px] mt-12 mb-12">
          We follow modern software engineering practices that prioritize clean architecture, performance optimization, and user-centered design. The team actively explores new technologies and evolves internal processes to maintain high technical excellence across every project.
        </p>

        <div className="w-16 h-[1px] bg-accent-500"></div>
      </div>
    </section>
  );
}